const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const { getChequebookApiStatusValue } = require('utilities/APIParsingHelper');
const get = require('lodash/object/get');
const accountChequesActions = require('actions/accountCheques');
const { requestAccounts } = require('actions/getAccounts');

const requestAccountChequebook = (accountId, chequebookId) => ({
    type: actionTypes.FETCH_ACCOUNT_CHEQUEBOOK_REQUEST,
    payload: {
        accountId,
        chequebookId
    }
});

const requestAccountChequebookSuccess = (data, accountId, chequebookId) => ({
    type: actionTypes.FETCH_ACCOUNT_CHEQUEBOOK_SUCCESS,
    payload: {
        accountId,
        chequebookId,
        chequebook: get(data, 'listaTalonarios.talonarios', []),
        irregularChequebook: get(data, 'listaTalonariosAnomalos.talonariosAnomalos', []),
        nextPage: get(data, '_links.nextPage.href', '')
    }
});

const requestAccountChequebookFailure = (error, accountId, chequebookId) => ({
    type: actionTypes.FETCH_ACCOUNT_CHEQUEBOOK_FAILURE,
    payload: {
        accountId,
        chequebookId,
        error
    }
});

const requestAccountChequebookNextPage = (accountId, chequebookId) => ({
    type: actionTypes.FETCH_ACCOUNT_CHEQUEBOOK_NEXT_PAGE_REQUEST,
    payload: {
        accountId,
        chequebookId
    }
});

const requestAccountChequebookNextPageSuccess = (data, accountId, chequebookId) => ({
    type: actionTypes.FETCH_ACCOUNT_CHEQUEBOOK_NEXT_PAGE_SUCCESS,
    payload: {
        accountId,
        chequebookId,
        chequebook: get(data, 'listaTalonarios.talonarios', []),
        nextPage: get(data, '_links.nextPage.href', '')
    }
});

const setAccountChequebookFilter = (selected, accountId) => ({
    type: actionTypes.FETCH_ACCOUNT_CHEQUEBOOK_SET_FILTER,
    payload: {
        accountId,
        selected
    }
});

function getAccountChequebook(dispatch, getState, accountId, chequebookIndex) {
    const immCheques = getState().accountsCheques.get(accountId);
    const chequebookId = immCheques.get('byOrder').get(chequebookIndex);
    const immChequebook = immCheques.get('byId').get(chequebookId);

    const immAccount = getState().accounts.get('byId').get(accountId);

    const requestData = {
        query: {
            producto: immAccount.get('newProduct'),
            contrato: immAccount.get('newContractNumber'),
            codMoneda: immChequebook.get('currency'),
            numChequeInicial: immChequebook.get('initialNum')
        }
    };

    const status = getChequebookApiStatusValue(immCheques.get('chequebookFilter'));
    if (status){
        requestData.query.indicadorSituacion = status;
    }

    dispatch(requestAccountChequebook(accountId, chequebookId));

    return APIGet({
        dispatch,
        endpoint: 'accountChequebook',
        url: apiURLBuilder.getURL('accountChequebook'),
        params: requestData
    })
    .then((response) => dispatch(requestAccountChequebookSuccess(response, accountId, chequebookId)))
    .catch((response) => dispatch(requestAccountChequebookFailure(response.error, accountId, chequebookId)))
}

const requestNextAccountChequebookPage = (accountId, chequebookId) => (dispatch, getState) => {
    const nextPageURL = getState().accountsCheques.get(accountId).get('chequebooks').get(chequebookId).get('nextPage');

    dispatch(requestAccountChequebookNextPage(accountId, chequebookId));
    return APIGet(dispatch, nextPageURL)
        .then((response) => dispatch(requestAccountChequebookNextPageSuccess(response, accountId, chequebookId)))
        .catch((response) => dispatch(requestAccountChequebookFailure(response.error, accountId, chequebookId)))
}

const requestChequebook = (accountId, chequebookIndex) => (dispatch, getState) => {
    return dispatch(requestAccounts())
        .then(() => {
            const immAccount = getState().accounts.get('byId').get(accountId);
            const immCheques = getState().accountsCheques.get(accountId);

            if (immCheques && !immCheques.get('error')) {
                //requestChequebook
                getAccountChequebook(dispatch, getState, accountId, chequebookIndex);
            } else {
                //requestCheques and then requestChequebook
                accountChequesActions.getAccountCheques(dispatch, immAccount, accountId).then(() => {
                    getAccountChequebook(dispatch, getState, accountId, chequebookIndex);
                });
            }
        })
}

module.exports = {
    requestNextAccountChequebookPage,
    requestChequebook,
    setAccountChequebookFilter
}
